module.exports = __webpack_public_path__ + "static/media/JustActMailers_9_V1-01.4c8b75c7.jpg";